import React from 'react';

const DAYS_LABELS = ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש'];

const StreakGraph = ({ logs = {} }) => {
  // Get last 14 days
  const days = Array.from({ length: 14 }, (_, i) => {
    const d = new Date();
    d.setDate(d.getDate() - (13 - i));
    return d;
  });

  const getStatus = (date) => {
    const key = date.toISOString().split('T')[0];
    if (logs[key]) return logs[key].isClean ? 'clean' : 'lapse';
    if (date < new Date()) return 'skip';
    return 'future';
  };

  const STATUS_COLOR = {
    clean: 'bg-brand-500',
    lapse: 'bg-bloom-500',
    skip: 'bg-stone-200',
    future: 'bg-stone-100',
  };

  // Running streak length ending at each day, so bar height shows the streak
  // actually building up (and resetting on a lapse) - not just how recent the day is.
  const statuses = days.map(getStatus);
  const runningStreaks = statuses.map((_, i) => {
    let run = 0;
    for (let j = i; j >= 0 && statuses[j] === 'clean'; j--) run++;
    return run;
  });
  const maxRun = Math.max(...runningStreaks, 1);

  return (
    <div className="bg-white rounded-xl p-4 border border-stone-100 shadow-sm">
      <h3 className="font-bold text-stone-800 mb-4 text-sm">📈 14 ימים אחרונים</h3>

      {/* Bar Graph */}
      <div className="flex items-end gap-1 h-16 mb-2">
        {days.map((day, i) => {
          const status = statuses[i];
          const height = status === 'clean'
            ? `${Math.max((runningStreaks[i] / maxRun) * 100, 15)}%`
            : status === 'lapse' ? '20%' : '10%';
          return (
            <div key={i} className="flex-1 flex flex-col items-center gap-1">
              <div
                className={`w-full rounded-t-sm transition-all ${STATUS_COLOR[status]}`}
                style={{ height }}
              />
            </div>
          );
        })}
      </div>

      {/* Day dots */}
      <div className="flex gap-1">
        {days.map((day, i) => {
          const status = statuses[i];
          return (
            <div key={i} className="flex-1 flex flex-col items-center">
              <div className={`w-2 h-2 rounded-full ${STATUS_COLOR[status]}`} />
              <span className="text-stone-400 mt-1" style={{ fontSize: '8px' }}>
                {DAYS_LABELS[day.getDay()]}
              </span>
            </div>
          );
        })}
      </div>

      {/* Legend */}
      <div className="flex gap-3 mt-3 text-xs text-stone-500">
        <div className="flex items-center gap-1">
          <div className="w-2 h-2 rounded-full bg-brand-500" />
          <span>נקי</span>
        </div>
        <div className="flex items-center gap-1">
          <div className="w-2 h-2 rounded-full bg-bloom-500" />
          <span>נפילה</span>
        </div>
        <div className="flex items-center gap-1">
          <div className="w-2 h-2 rounded-full bg-stone-200" />
          <span>לא סומן</span>
        </div>
      </div>
    </div>
  );
};

export default StreakGraph;
